import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const isBrowser = typeof window !== "undefined";
const detectionOrder = isBrowser ? ["subdomain"] : ["header"];

export const i18nInitOptions = {
	detection: {
		order: detectionOrder,
		caches: [],
		lookupFromSubdomainIndex: 0,
	},
	initImmediate: true,
	debug: false,
	fallbackLng: "pl",
	load: "languageOnly",
	ns: [
		"common",
		"contact",
		"countries",
		"filtersAndSelectors",
		"landing",
		"languages",
		"notifications",
		"pages",
		"regions",
		"report",
		"suspensions",
		"userpanel",
		"users",
		"userProfile",
	],
	defaultNS: "common",
	supportedLngs: ["pl", "en", "de", "cs", "ru", "uk"],
	preload: false,
	react: {
		useSuspense: false,
	},
};

if (process && !process.release) {
	i18n.use(Backend).use(initReactI18next).use(LanguageDetector);
}
if (!i18n.isInitialized) {
	i18n.init(i18nInitOptions);
}

export default i18n;
